interface Props {
    id: string;
    name: string;
}

export default class VersionGroup {

    public constructor(private readonly props: Props) {
    }

    public getId(): string {
        return this.props.id;
    }

    public getName(): string {
        return this.props.name;
    }
}
